// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"edfa8f07","239":"21a27322","453":"1b9bc311","732":"29354054"}[chunkId] + ".chunk.js";
};